import { useMutation, useQueryClient } from "react-query";

import { crearCargo, updateCargo, deleteCargo} from '../../services/Cargos';

import { toast } from 'react-hot-toast';
const queryKey = "cargos";

export const useCargosMutations = () => {
  const queryClient = useQueryClient();
  const onError = (err = null) => {
    if (err.statusCode === 409) {
      return toast.error(`El valor ${err.duplicateValue} ya se encuentra registrado`);
    }
    toast.error('Error consulte con Soporte!');
  };

  const onSuccess = () => {
    toast.success('Datos Guardados Exitosamente!');
    queryClient.invalidateQueries(queryKey);
  };

  const addCargo = useMutation((body) => crearCargo(body), {
    onSuccess,
    onError: (err) => onError(err),
  });

  const updateCargoC = useMutation((body) => updateCargo(body), {
    onSuccess,
    onError: (err) => onError(err),
  });

  const removeCargo = useMutation((id) => deleteCargo( id), {
    onSuccess,
    onError,
  });

  return { addCargo, updateCargoC, removeCargo };
};
export default useCargosMutations;